import React from 'react';
import { ToastContainer } from 'react-toastify';
import './styles.scss';

export const AlertToastContainer = props => {
  return <ToastContainer className="alert-toast-container" {...props} />;
};
